import { memo } from "react"

import { CellProps } from "components/TreeState"
import { GrossCostCell } from "./GrossCostCell"
import { NumericCell } from "./NumericCell"
import { ReadonlyCell } from "./ReadonlyCell"
import { VariableCost } from "./VariableCost"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { useSnapshot } from "valtio"
import { useTableSource } from "../TableStateProvider"

export const ReadonlyDualNumericCell = memo(function _ReadonlyDualNumeriCell(
  props: CellProps,
) {
  return <DualNumericCell {...props} viewOnly={true} />
})

export const DualNumericCell = memo(function _DualNumericCell(
  props: CellProps & { viewOnly?: boolean },
) {
  const { t } = useI18n()
  const {
    rowId: id,
    id: fieldId,
    secondaryKey,
    disabled,
    editType,
    viewOnly,
    semantic,
    viewType,
  } = props
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const type = readFrom[id]?.type
  const isMediaSubmedia =
    type === "media_type_plan" || type === "media_subtype_plan"
  const displaySecondary = !disabled && !isMediaSubmedia
  const dualLabel =
    viewType === "CLIENT_AGENCY"
      ? t("planning.values")
      : t("intercompany.values")

  let Cell = NumericCell
  editType === "VariableCost" && (Cell = VariableCost)
  editType === "Calculated" && (Cell = ReadonlyCell)
  semantic === "grossCost" && (Cell = GrossCostCell)

  return (
    <div className={styles.wrapper}>
      <div className={styles.primary}>
        <Cell {...props} />
      </div>
      {displaySecondary ? (
        <div className={styles.secondary}>
          {dualLabel}
          <Cell
            {...props}
            dataKey={`${secondaryKey}.${fieldId}`}
            disabled={!!viewOnly}
            bulkDisabled
          />
        </div>
      ) : null}
    </div>
  )
})

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
  `,
  input: css`
    font-size: 13px;
    font-weight: inherit;
    border-width: 0;
    text-align: end;
  `,
  primary: css`
    display: flex;
  `,
  secondary: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--dark-grey-2);
    font-size: 13px;
  `,
  secondaryInput: css`
    text-align: end;
    font-weight: inherit;
  `,
}
